<app-navbar></app-navbar>
<div class="hos-admin-container">
  <app-tabs
    [tabs]="adminTabs"
    [routingStyle]="'path'"
    [defaultTab]="'UserOverview'"
    (tabChanged)="onTabChange($event)"
  ></app-tabs>

  <div class="tab-content">
    <router-outlet></router-outlet>
  </div>
</div>
